import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, BookOpen, Target, Globe, Church } from 'lucide-react';

const Sobre = () => {
  const valores = [
    {
      icon: BookOpen,
      titulo: 'Ler a Bíblia',
      descricao: 'Valorizamos o estudo e a meditação diária da Palavra de Deus como fundamento para nossa fé e prática.',
    },
    {
      icon: Heart,
      titulo: 'Orar',
      descricao: 'Cultivamos uma vida de oração constante, buscando intimidade com Deus e dependência do Espírito Santo.',
    },
    {
      icon: Users,
      titulo: 'Jejuar',
      descricao: 'Praticamos o jejum como disciplina espiritual para buscar a face de Deus e fortalecer nossa vida espiritual.',
    },
    {
      icon: Heart,
      titulo: 'Amar',
      descricao: 'Amamos a Deus sobre todas as coisas e ao próximo como a nós mesmos, seguindo o maior mandamento de Jesus.',
    },
    {
      icon: Users,
      titulo: 'Servir',
      descricao: 'Servimos com excelência e humildade, reconhecendo que fomos chamados para servir e não para ser servidos.',
    },
    {
      icon: Church,
      titulo: 'Edificar',
      descricao: 'Edificamos vidas através do discipulado e do ensino da Palavra, formando discípulos maduros e comprometidos.',
    },
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] via-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Quem Somos
            </h1>
            <p className="text-xl md:text-2xl text-[#B8C4E3]">
              Ministério Evangelístico Vinde Amados Meus - Uma família de fé que ama, serve e edifica
            </p>
          </motion.div>
        </div>
      </section>

      {/* Nossa História */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Nossa História
              </h2>
              <p className="text-[#B8C4E3] text-lg mb-6">
                O <strong className="text-white">MEVAM Brasília</strong> nasceu em 2020 com o propósito de ser uma igreja 
                que ama, serve e edifica. Desde o início, nossa visão tem sido clara: Ser uma 
                comunidade que transforma vidas através do evangelho de Jesus Cristo.
              </p>
              <p className="text-[#B8C4E3] text-lg mb-6">
                Fundado pelo Pastor Anderson Rabis, o MEVAM Brasília começou como um pequeno grupo 
                de pessoas comprometidas com a visão de alcançar Brasília com a mensagem do evangelho. 
                Ao longo desses anos, temos crescido não apenas em número, mas principalmente em 
                maturidade espiritual e impacto na comunidade.
              </p>
              <p className="text-[#B8C4E3] text-lg">
                Fazemos parte do <strong className="text-white">MEVAM Global fundada pelo Apóstolo Luiz Hermínio</strong>, 
                compartilhando dos mesmos princípios e valores que norteiam este ministério de alcance mundial.
              </p>
            </motion.div>
            {/*
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative"
            >
              
              <div className="bg-gradient-to-br from-[#17E6B3] to-[#17E6B3]/70 rounded-2xl p-8 text-[#030B2E] shadow-xl shadow-[#17E6B3]/20"> 
                <div className="text-center mb-6">
                  <div className="w-24 h-24 bg-[#030B2E]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Church size={40} className="text-[#030B2E]" />
                  </div>
                  <h3 className="text-2xl font-bold">5 Anos de Ministério</h3>
                </div>
                <div className="space-y-4 text-[#030B2E]">
                  <div className="flex items-center justify-between">
                    <span>Fundação</span>
                    <strong>2019</strong>
                  </div>
                  <div className="flex items-center justify-between">
                    <span>Vidas Transformadas</span>
                    <strong>200+</strong>
                  </div>
                  <div className="flex items-center justify-between">
                    <span>Famílias Alcançadas</span>
                    <strong>50+</strong>
                  </div>
                  <div className="flex items-center justify-between">
                    <span>Ministérios Ativos</span>
                    <strong>15+</strong>
                  </div>
                </div>
              </div>
            </motion.div>
            */}
          </div>
        </div>
      </section>

      {/* Liderança */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Nossa Liderança
            </h2>
            <p className="text-[#B8C4E3] text-lg max-w-2xl mx-auto">
              Conheça quem Deus tem usado para pastorear e liderar nossa comunidade de fé.
            </p>
          </motion.div>
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-8"
            >
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                <div className="text-center">
                  <div className="w-48 h-48 bg-gradient-to-br from-[#17E6B3] to-[#17E6B3]/70 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg shadow-[#17E6B3]/30 overflow-hidden">
                      <img src="/anderson.png" alt="Pastor Anderson Rabis" className="w-full h-full object-cover" />
                    </div>
                </div>
                <div className="md:col-span-2">
                  <h3 className="text-2xl font-bold text-white mb-4">
                    Pastor Anderson Rabis
                  </h3>
                  <p className="text-[#B8C4E3] text-lg mb-4">
                    Líder visionário e apaixonado pela Palavra de Deus, o Pastor Anderson Rabis tem 
                    dedicado sua vida a edificar a igreja e formar discípulos comprometidos com o Reino.
                  </p>
                  <p className="text-[#B8C4E3] text-lg">
                    Com um coração pastoral e profético, ele tem conduzido o MEVAM Brasília com 
                    sabedoria e amor, inspirando cada membro a viver uma vida de intimidade com Deus e 
                    impacto na sociedade.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Visão e Missão */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-8"
            >
              <div className="text-center mb-6">
                <Target className="text-[#17E6B3] mx-auto mb-4" size={48} />
                <h3 className="text-2xl font-bold text-white">Nossa Visão</h3>
              </div>
              <div className="space-y-4 text-[#B8C4E3]">
                <p>
                  Somos uma igreja que acredita em um evangelho que se aproxima, pensamos em um 
                  evangelho que não desiste das pessoas, pensamos em uma igreja que o pecado será 
                  tratado com rigor, mas o pecador será tratado com amor.
                </p>
                <p>
                  Somos um lugar de encorajadores, Deus nos disse segurar as mãos uns dos outros e 
                  fale "bora", vamos chegar até o final juntos, ninguém irá ficar pra trás.
                </p>
                <p>
                  Somos uma igreja evangelizadora, alegre e vibrante, intercessora, centrada na 
                  Palavra, chamada à comunhão e discipuladora.
                </p>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-8"
            >
              <div className="text-center mb-6">
                <Globe className="text-[#17E6B3] mx-auto mb-4" size={48} />
                <h3 className="text-2xl font-bold text-white">Nossa Missão</h3>
              </div>
              <div className="space-y-4 text-[#B8C4E3]">
                <p>
                  Nossa visão é <strong className="text-white">levar cada pessoa a um relacionamento público e crescente com Jesus</strong>.
                </p>
                <p>
                  Carregamos como missão <strong className="text-white">ganhar nossa cidade para Cristo</strong>, 
                  impactando Brasília com o amor de Deus.
                </p>
                <div className="bg-gradient-to-r from-[#17E6B3] to-[#17E6B3]/80 text-[#030B2E] p-4 rounded-lg text-center mt-6 shadow-lg shadow-[#17E6B3]/20">
                  <h4 className="font-bold text-lg">MEVAM Brasília é</h4>
                  <p className="font-semibold">
                    Corações que Amam, Mãos que Servem, Vidas que Edificam.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Nossos Valores */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Nossos Valores
            </h2>
            <p className="text-[#B8C4E3] text-lg max-w-2xl mx-auto">
              Os pilares que fundamentam nossa caminhada cristã e norteiam nossas ações como comunidade de fé.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {valores.map((valor, index) => {
              const IconComponent = valor.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-6 text-center hover:shadow-2xl hover:shadow-[#17E6B3]/20 transition-all duration-300"
                >
                  <IconComponent className="text-[#17E6B3] mx-auto mb-4" size={40} />
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {valor.titulo}
                  </h3>
                  <p className="text-[#B8C4E3]">{valor.descricao}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Bem-vindo ao MEVAM
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto text-[#B8C4E3]">
              Uma igreja cristã que ama, serve e edifica vidas há 5 anos. Filiada ao MEVAM Global, 
              somos uma comunidade acolhedora comprometida em transformar vidas através do amor de Cristo.
            </p>
            <p className="text-lg mb-8 max-w-2xl mx-auto text-[#B8C4E3]">
              Participe de nossos cultos, grupos de crescimento e projetos sociais. 
              Venha fazer parte desta família de fé!
            </p>
            <motion.a
              href="/contato"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-[#17E6B3] hover:bg-[#17E6B3]/90 text-[#030B2E] font-semibold py-3 px-8 rounded-xl transition-all inline-flex items-center shadow-lg shadow-[#17E6B3]/30"
            >
              <Users className="mr-2" size={20} />
              QUERO FAZER PARTE
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Sobre;